module.exports = __webpack_public_path__ + "static/media/Live.189d75a1.png";